"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  tableCell: {
    boxSizing: 'border-box',
    padding: '0 22px',
    fontSize: theme.table.cellFontSize,
    '&:first-child': {
      paddingLeft: 0
    },
    '&:last-child': {
      paddingRight: 0
    },
    '&.ellipsis': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '&.hidden': {
      display: 'none'
    }
  }
});

exports.default = _default;